<template>
    <div class="p-6 dark:text-white space-y-6">
         <div class="flex items-center gap-3 mb-8">
            <ChartNetwork class="bg-white/20"/>
            <h1 class="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white">
                API Key Management
            </h1>
        </div>
        
        <div class="backdrop-blur-sm py-3 glass-card-lite">
            <div class="mx-auto px-6">
                <nav class="flex space-x-1">
                    <button
                        v-for="tab in tabs"
                        :key="tab.id"
                        @click="activeTab = tab.id"
                        :class="[
                        'px-6 py-4 font-bold transition-all duration-200 flex items-center space-x-2 rounded-md border border-white glass-card',
                        activeTab === tab.id
                            ? 'bg-transparent text-fuchsia-500'
                            : 'text-gray-400 hover:bg-slate-800/30 hover:text-fuchsia-500  bg-transparent'
                        ]"
                    >
                        <component :is="tab.icon" class="w-4 h-4" />
                        <span>{{ tab.label }}</span>
                    </button>
                </nav>
            </div>
        </div>

        <iframe 
            class="w-full h-screen p-6  glass-card-lite" 
            :src="grafanaUrl"
            frameborder="0">
        </iframe>
    </div>
</template>

<script setup>
import { ref, computed, h } from 'vue';
import OverviewView from './OverviewView.vue';
import UsersView from './UsersView.vue';
import WhitelistView from './WhitelistView.vue';
import ApiKeyView from './ApiKeyView.vue';
import FirmwareView from './FirmwareView.vue';
import { 
  HeartPulse,
  BarChart,
  ChartNetwork,
  ChartNetworkIcon
} from 'lucide-vue-next';


const tabs = [
  { id: 'esp32-device-status', label: 'Device Status', icon: BarChart },
  { id: 'esp32-system-health', label: 'System Health', icon: HeartPulse },
];

const activeTab = ref('esp32-device-status');

const grafanaUrl = computed(() => `/grafana/d/${activeTab.value}/${activeTab.value}-metrics/`)

</script>